import React from 'react';
import './About.css';
import aboutImage from '../../assets/images/about-image.jpg';

const About = () => {
  return (
    <section className="about-section">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img src={aboutImage} alt="Our training facility" />
          </div>
          <div className="about-text">
            <h2 className="section-title">About Our Training Center</h2>
            <p>
              Home Aide CNA Bridge Training Center has been providing exceptional healthcare education since 2024. 
              Our mission is to equip students with the skills and knowledge needed to excel in the healthcare field.
            </p>
            <div className="about-features">
              <div className="feature">
                <div className="feature-icon">🏆</div>
                <h3>State-Approved Program</h3>
                <p>All our Training meet Washington state requirements</p>
              </div>
              <div className="feature">
                <div className="feature-icon">👩‍⚕️</div>
                <h3>Experienced Instructors</h3>
                <p>Learn from healthcare professionals with real-world experience</p>
              </div>
              <div className="feature">
                <div className="feature-icon">📚</div>
                <h3>Modern Facilities</h3>
                <p>State-of-the-art equipment and learning resources</p>
              </div>
              <div className="feature">
                <div className="feature-icon">🤝</div>
                <h3>Job Placement</h3>
                <p>Career support and job placement assistance</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;